import { ThresholdsInterface } from "./types";

export const defaultThresholdData:ThresholdsInterface = {
    cpu: {yellow: 70, red: 90},
    disk: {yellow: 20971520, red: 41943040},
    memory: {yellow: 70, red: 90},
    processes: [],
    foldersPath: []
}